import React, { useState, useRef, useCallback } from 'react';
import { Button } from 'react-bootstrap';

import { useUserContext } from 'providers/UserProvider';
import CreateReturnManifestModal from 'components/add_return/return-manifest/CreateReturnManifestModal';

import Table from 'components/common/Table';

import { returnManifestApi } from 'api';

import {
  getReturnManifestListTab,
  getReturnManifestListColumns,
  RETURN_MANIFEST_FILTER_OPTIONS,
} from 'constants/returnManifest';

const ReturnManifests = () => {
  const tableRef = useRef();
  const [showCreateReturnManifestModal, setShowCreateReturnManifestModal] =
    useState(false);

  const { selectedTenant, selectedWarehouse } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;
  const initialFilter = { warehouse: selectedWarehouse?.id };

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => setShowCreateReturnManifestModal(true)}
    >
      Create Return Manifest
    </Button>
  );

  const exportApi = useCallback(params => {
    return returnManifestApi.exportReturnManifest(params);
  }, []);

  const handleCreateSuccess = () => {
    tableRef.current?.refetch();
  };

  return (
    <>
      <Table
        ref={tableRef}
        title="Return Manifests"
        apiService={returnManifestApi}
        exportApi={exportApi}
        sortable={true}
        columns={getReturnManifestListColumns(tenant, warehouse)}
        filterOptions={RETURN_MANIFEST_FILTER_OPTIONS}
        tabOptions={getReturnManifestListTab(initialFilter)}
        initialFilter={initialFilter}
        headerActions={headerActions}
      />

      <CreateReturnManifestModal
        show={showCreateReturnManifestModal}
        onHide={() => setShowCreateReturnManifestModal(false)}
        onSuccess={handleCreateSuccess}
      />
    </>
  );
};

export default ReturnManifests;
